import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { SUPPORTED_LANGUAGES } from './languageConfig';

import nl from './locales/nl.json';
import en from './locales/en.json';
import pl from './locales/pl.json';
import ro from './locales/ro.json';
import bg from './locales/bg.json';
import hu from './locales/hu.json';
import de from './locales/de.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import uk from './locales/uk.json';
import tr from './locales/tr.json';
import lt from './locales/lt.json';
import cs from './locales/cs.json';
import sk from './locales/sk.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      nl: { translation: nl },
      en: { translation: en },
      pl: { translation: pl },
      ro: { translation: ro },
      bg: { translation: bg },
      hu: { translation: hu },
      de: { translation: de },
      es: { translation: es },
      pt: { translation: pt },
      uk: { translation: uk },
      tr: { translation: tr },
      lt: { translation: lt },
      cs: { translation: cs },
      sk: { translation: sk },
    },
    fallbackLng: 'nl',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'worker-app-language',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

document.documentElement.lang = i18n.resolvedLanguage ?? 'nl';
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
